import { render, staticRenderFns } from "./ValidateMFA.vue?vue&type=template&id=878decee&scoped=true"
import script from "./ValidateMFA.vue?vue&type=script&lang=ts"
export * from "./ValidateMFA.vue?vue&type=script&lang=ts"
import style0 from "./ValidateMFA.vue?vue&type=style&index=0&id=878decee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878decee",
  null
  
)

export default component.exports